import styled from "styled-components";
import { breakpoints } from "../../../../../constants/media";

const Container = styled.div`
  width: 286px;
  height: auto;
  max-height: 500px;
  min-height: 500px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  align-items: flex-start;
  align-content: flex-start;
  margin: 0 auto;
  margin-top: calc(100vh - 85vh - 20px);
  background: #fff;
  box-shadow: 0px 5px 30px rgba(9, 30, 66, 0.15);
  border-radius: 6px;
  overflow: auto;
  padding: 17px;
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 100;

  // Close Button Container
  .closeButtonContainer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  // Clouse Button
  .closeButtonContainer a {
    cursor: pointer;
    font-size: 1.5em;
    color: var(--black);
    transition: 0.1s all;
  }

  .closeButtonContainer a:hover {
    color: var(--orange) !important;
  }

  // Title
  h3 {
    width: 100%;
    text-align: center;
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    color: var(--black);
    margin: 0px 0px 0px 0px;
  }

  // Text
  p {
    width: 100%;
    max-width: 225px;
    text-align: center;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    margin: 25px 0px 0px 0px;
  }

  // Input Container
  .inputContainer {
    margin: 25px 0px 0px 0px;
    min-width: 270px;
    max-width: 270px;
  }

  // Labels
  .inputContainer label {
    display: block;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: var(--black);
    margin: 0px 0px 6px 0px;
  }

  // Input
  .inputContainer input {
    width: calc(100% - 32px);
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 0.75em;
    padding: 0px 15px 0px 15px;
    height: 29px;
    border: 1px solid var(--lightgray);
    transition: all 0.25s ease;
    color: var(--lightgray);
    outline: 0;
    border-radius: 3px;
    margin: 0px 0px 0px 0px;
  }

  .inputContainer input:focus {
    border: 1px solid var(--orange);
  }

  .inputError {
    border: 1px solid red !important;
  }

  // Input Error Text
  .inputContainer p {
    min-height: 25px !important;
    content: "";
    margin: 0px 0px 0px 0px !important;
    max-width: 100% !important;
  }

  .inputContainer p span {
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    color: red !important;
    margin: 0px 0px 0px 0px;
    font-size: 0.8em;
    text-align: center;
  }

  // Referir button
  #referirButton {
    text-align: center;
    color: var(--white);
    border: 0px;
    background-color: var(--blue);
    cursor: pointer;
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    padding: 10px 40px 10px 40px;
    border-radius: 6px;
    margin: 112px 0px 15px 0px;
    transition: 0.2s all;
  }

  #referirButton:hover {
    background-color: var(--lightblue);
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    right: 0;
    left: 0;
    box-shadow: 0px 10px 40px rgba(9, 30, 66, 0.25);
    top: 0;
  }
`;

export default Container;
